<!--  -->
<template>
  <div class="container">
    <!-- pic 1-->
    <div class="pic1-panel" v-show="activePage === 0">
      <div class="left-panel">
        <h3>智能到家,孕期无忧</h3>
        <div class="desc-wrapper">
          <p>孕e家与全国各大知名医院强强联合，携手上千位资深妇产科医生，为百万孕妇打造了一个专属平台，提供了孕妇学校、远程监护等多种个性化功能 。动动手指，马上下载APP，让孕e家成为你的孕期好帮手。
            <!--<a
              href="http://yunejia.gzmoninet.com/website/yunejia/index.html"><span>查看详情<img
                  src="../../../../assets/images/btn_double_arrow_pink.png"></span></a>--></p>
        </div>
        <div class="qrcode-wrapper">
          <div>
            <img src="../../../../assets/images/img_p1_1_code.png" alt="孕e家二维码">
            <p>扫一扫 马上下载</p>
          </div>
        </div>
      </div>
      <div class="right-panel">
        <img src="../../../../assets/images/img_p1_1_phone.png" alt="截图">
      </div>
    </div>
    <!-- pic 2-->
    <!-- <div class="pic2-panel" v-show="activePage === 1">
      <img src="../../../../assets/images/img_p1_2_phone.png" alt="截图">
    </div> -->
    <!--pic 3-->
    <div v-show="activePage === 1" class="pic3-panel">
      <div class="pic3-text-panel">
        <div class="feat-item">
          <div class="feat-wrapper">
            <div class="text-wrapper">
              <h3>备孕助手</h3>
              <p>专业辅助生殖，精准预测你的排卵日，抓住最佳同房时机，让你备孕倍感轻松。</p>
            </div>
            <div class="icon-logo">
              <img src="../../../../assets/images/icon_p1_3_consult.png" alt="">
            </div>
          </div>
        </div>
        <div class="feat-item">
          <div class="feat-wrapper">
            <div class="text-wrapper">
              <h3>孕妇学校</h3>
              <p>三甲医院、知名专家独家授课。这里有精美视频讲课，有常见问题音频答疑，足不出户便知孕期知识。</p>
            </div>
            <div class="icon-logo">
              <img src="../../../../assets/images/icon_p1_3_encyclopedia.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="pic3-middle-panel">
        <img src="../../../../assets/images/img_p1_3_phone.png" alt="">
      </div>
      <div class="pic3-text-panel">
        <div class="feat-item">
          <div class="feat-wrapper">
            <div class="icon-logo">
              <img src="../../../../assets/images/icon_p1_3_remote.png" alt="">
            </div>
            <div class="text-wrapper text-right">
              <h3 class="left-title">孕期百科</h3>
              <p>涵盖备孕、孕期、产后各阶段的各类资讯。了解饮食保健、知晓疾病防治、学习产检意义，让你每天都有新收获。</p>
            </div>
          </div>
        </div>
        <div class="feat-item">
          <div class="feat-wrapper">
            <div class="icon-logo">
              <img src="../../../../assets/images/icon_p1_3_school.png" alt="">
            </div>
            <div class="text-wrapper text-right">
              <h3 class="left-title">远程监控</h3>
              <p>你用胎监守护宝宝，我用专业守护你们。随时监测宝宝胎心变化，了解宝宝的发育情况，妈妈孕期更安心。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- pic 4-->
    <!-- <div class="pic4-panel" v-show="activePage === 3">
      <h3>远程监护 智能穿戴硬件</h3>
      <div class="web-msg-link"><span @click="toLicensePage(4)">医疗器械经营备案凭证</span></div>
      <div class="pic4-product-panel">
        <div class="product-item">
          <img src="../../../../assets/images/img_p1_4_instruments1.png" alt="">
          <h4>多体征采集器</h4>
          <p>可便捷测量血压、血氧、血糖、脉率、体重五种体征.</p>
          <div class="web-msg" v-if="switchInfo.multiDevice"><span @click="toLicensePage(1)">多体征注册证(粤械注准:20162210961)</span></div>
        </div>
        <div class="product-item">
          <img src="../../../../assets/images/img_p1_4_instruments2.png" alt="">
          <h4>胎儿监护仪</h4>
          <p>适用于孕晚期胎儿心率、胎动和孕妇宫缩压力的连续监护.</p>
          <div class="web-msg" v-if="switchInfo.fetalDevice"><span @click="toLicensePage(2)">胎儿监护仪注册证(粤械注准:20142180065)</span></div>
        </div>
        <div class="product-item">
          <img src="../../../../assets/images/img_p1_4_instruments3.png" alt="">
          <h4>超声胎音仪</h4>
          <p>一款采用多普勒原理对胎儿心跳捕捉、获取胎心信号的超声胎音仪，可听到16周以上的胎儿心血管壁博动.</p>
          <div class="web-msg" v-if="switchInfo.superFetal"><span @click="toLicensePage(3)">超声胎音仪注册证(粤械注准:20192180860)</span></div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import 'jquery'
  import http from '../../../../api/http.js'
  import apiUrl from '../../../../api/apiUrl.js'

  export default {
    name: '',
    data() {
      return {
        activePage: 0,
        switchInfo: {
          multiDevice: false,
          fetalDevice: false,
          superFetal: false
        }
      }
    },

    props: [],

    watch: {},

    components: {},

    computed: {},

    created() {
      this.fetchSwitchInfo()
    },

    methods: {
      toLicensePage(e) {
        let routeUrl = this.$router.resolve({
          name: 'deviceLicense',
          query: {
            pageType: e
          }
        })
        window.open(routeUrl.href, '_blank');
      },
      // 获取新闻页数据
      fetchSwitchInfo() {
        const test = new Date().getTime();
        http.get(apiUrl.deviceSwitch)
          .then(response => {
            if (response.code == 0) {
              for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].itemKey == 'FETAL_HEART_CERTIFICATE_WEBSITE_SWITCH') {
                  this.switchInfo.superFetal = response.data[i].itemValue
                } else if (response.data[i].itemKey == 'XICOO_WEBSITE_CERTIFICATE_SWITCH') {
                  this.switchInfo.multiDevice = response.data[i].itemValue
                } else if (response.data[i].itemKey == 'FETAL_MONITOR_CERTIFICATE_WEBSITE_SWITCH') {
                  this.switchInfo.fetalDevice = response.data[i].itemValue
                }
              }
            }
          })
      }
    }
  }

</script>
<style lang='scss' scoped>
  .container {
    width: 100%;

    .web-msg {
      margin-top: 16px;
      font-size: 16px;
      color: #FF789E;
      line-height: 24px;

      span {
        a {
          color: #FF789E;
          text-decoration: none;
        }
      }

      span:hover {
        font-weight: 900;
        cursor: pointer;
      }

    }
    .web-msg-link{
      margin-top: 25px;
      font-size: 20px;
      color: #FF789E;
      line-height: 30px;
      span:hover {
        font-weight: 900;
        cursor: pointer;
      }
    }

    .pic1-panel {
      padding: 0 410px;
      display: flex;
      justify-content: space-between;

      .left-panel {
        display: inline-block;
        vertical-align: top;
        width: 600px;
        margin-top: 11vh;

        h3 {
          color: #FF789E;
          font-size: 30px;
          line-height: 42px;
          font-weight: 600;
          text-align: left;
          margin-bottom: 13px;
        }

        .desc-wrapper {
          width: 550px;

          p {
            color: #666;
            font-size: 18px;
            line-height: 30px;
            text-align: left;

            a {
              cursor: pointer;
              float: right;
            }

            a:hover {
              font-weight: 600;
              text-decoration: none;
            }
          }

          span {
            color: #FF789E;
            font-size: 18px;
            line-height: 30px;
            display: flex;
            align-items: center;

            img {
              margin-left: 2px;
              width: 18px;
              height: 18px;
            }
          }
        }

        .qrcode-wrapper {
          margin: 5vh 0 0 173px;
          text-align: left;

          div {
            width: 204px;
            height: 204px;

            img {
              width: 100%;
              height: 100%;
            }

            p {
              text-align: center;
              font-size: 24px;
              line-height: 33px;
              color: #FF789E;
              font-weight: 600;
            }
          }
        }
      }

      .right-panel {
        display: inline-block;
        vertical-align: top;
        width: 420px;
        height: 660px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .pic2-panel {
      padding: 0 410px;
      height: 640px;
      margin: 2.5% 0;
      display: flex;
      align-items: center;

      img {
        width: 100%;
        height: 95%;
      }
    }

    .pic3-panel {
      display: flex;
      align-items: center;
      margin-top: 60px;
      padding: 0 350px;
      height: 640px;

      .pic3-text-panel {
        display: inline-block;
        vertical-align: top;
        width: 462px;
        height: 520px;

        .feat-item {
          display: inline-block;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50%;
          box-sizing: border-box;

          .feat-wrapper {
            display: flex;

            .text-wrapper {
              display: inline-block;
              width: 342px;
              margin-right: 30px;

              h3 {
                margin-bottom: 8px;
                color: #FF789E;
                font-size: 30px;
                line-break: 42px;
                font-weight: 600;
                text-align: right;
              }

              p {
                color: #666;
                font-size: 18px;
                line-height: 25px;
                text-align: left;
              }

              .left-title {
                text-align: left;
              }
            }

            .text-right {
              margin-right: 0;
              margin-left: 30px;
            }

            .icon-logo {
              display: inline-block;
              vertical-align: top;
              width: 60px;
              height: 60px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      .pic3-middle-panel {
        display: inline-block;
        vertical-align: middle;
        width: 296px;
        height: 520px;
        padding: 0 34px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .pic4-panel {
      padding: 0 380px;

      h3 {
        color: #333;
        text-align: center;
        font-size: 28px;
        line-height: 40px;
        margin-top: 30px;
      }

      .pic4-product-panel {
        display: flex;
        justify-content: space-between;

        .product-item {
          display: inline-block;
          vertical-align: top;
          margin-top: 55px;
          width: 320px;

          img {
            width: 230px;
            height: 230px;
          }

          h4 {
            //margin-top: 43px;
            color: #FF789E;
            font-size: 28px;
            line-height: 38px;
            font-weight: 600;
          }

          p {
            min-height: 70px;
            margin-top: 15px;
            color: #666;
            font-size: 19px;
            line-height: 25px;
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/index/components/productBox/yunejia.vue